"use strict";
// 声明一个接口,名字叫 Treedata , 定义一个变量的类型,定义对象的属性名和属性的类型
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=type.js.map